import React, {useEffect, useState} from "react";




function TextBreak({text}) {
    const [body, setBody] = useState([])

    useEffect(() => {
        if(text){
            setBody(text.split("\n"));
        }
    }, [])

    return(
        <>
            {body.map(line=>{
                return(
                    <span style={styles.line}>{line}</span>
                )
            })}
        </>
    )
}

let styles= {
line:{
    fontFamily: "YekanMedium",
    fontSize: 13,
    direction: "rtl",
    width: "100%",
    textAlign: "justify"}
}

export {TextBreak};
